import { Directive, Type } from '@angular/core';

@Directive()
export class TableViewFilters {
  constructor(public component: Type<any>) {}
}
